<template>
    <Modal :mask-closable="false" title="钉钉用户" v-model="visible" width="600px">
      <Form ref="editDingForm" class="form" :model="formData" :rules="dingRules" :label-width="80">
        <Row>
          <Col :span="22">
            <Form-item label="钉钉用户" prop="dingtalkUserid">
              <Select  v-model="formData.dingtalkUserid" filterable transfer>
                <Option v-for="item in userList" :value="item.userId" :key="item.userId">{{item.userName}}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="22">
            <Form-item label="是否接收钉钉消息" prop="isReceiveMsg">
              <Select v-model.number="formData.isReceiveMsg" filterable transfer>
                <Option :value="1">是</Option>
                <Option :value="0">否</Option>
              </Select>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="visible=false">取消</Button>
        <Button type="primary" size="large" :loading="loadingAdd" @click="saveDing">保存</Button>
      </div>
    </Modal>
</template>

<script>
  export default {
    name: 'EditDingDingModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      tchId: {
        type: Number
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        visible: this.value,
        loadingAdd: false,
        userList: {},
        formData: {
          tchId: null,
          dingtalkDepartmentId: 135668087,
          dingtalkUserid: 0,
          isReceiveMsg: ''
        },
        dingRules: {
          dingtalkUserid: [
            { type: 'string', required: true, message: '请选择钉钉用户', trigger: 'blur' }
          ],
          isReceiveMsg: [
            { type: 'number', required: true, message: '请选择是否接收钉钉消息', trigger: 'blur' }
          ]
        }
      }
    },
    created: function () {
      this.loadDingtalkUser(135668087)
    },
    methods: {
      saveDing () {
        let self = this
        self.loadingAdd = true
        self.$refs.editDingForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingAdd = false
            return
          }
          if (self.formData.tchId) {
            self.$http.post('/tch/formal/saveOrUpdate', self.formData).then(function (res) {
              if (res.data > 0) {
                self.$Message.success('保存成功!')
                self.loadingAdd = false
                self.visible = false
                self.successCallback()
              }
            }).catch(function (e) {
              self.loadingAdd = false
              self.$Message.error(e.msg)
            })
          }
        })
      },
      loadDingtalkUser (val) {
        let self = this
        if (val) {
          self.$http.get('/dingTalk/userList?departmentId=' + val).then(function (res) {
            if (!res || !res.data) {
              return
            }
            self.userList = res.data
          })
        }
      },
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (!val) {
          this.userList = []
          this.formData = {}
          this.$emit('on-close', val)
        } else {
          // this.loadDingtalkUser(55523266)
        }
      },
      tchId (val) {
        if (val) {
          let self = this
          self.loadDingtalkUser(135668087)
          // self.loadDingtalkUser(55523266)
          self.$http.get('/tch/formal/queryByTchId?tchId=' + val).then(function (res) {
            if (res.data) {
              self.formData.tchId = res.data.tchId
              self.formData.dingtalkDepartmentId = 135668087
              self.formData.dingtalkUserid = res.data.dingtalkUserid
              if (!res.data.dingtalkUserid && res.data.isReceiveMsg === 0) {
                self.formData.isReceiveMsg = parseInt(1)
              } else {
                self.formData.isReceiveMsg = parseInt(res.data.isReceiveMsg)
              }
            }
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// EditDingDingModal.vue?1539b90a